// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse {
    static getAttributeTypeMap() {
        return SiteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse.attributeTypeMap;
    }
}
SiteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse.discriminator = undefined;
SiteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse.additionalProperties = false;
SiteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetSiteAccountsResponseModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=siteAccountV2SiteAccountSiteAccountsByPortalIdAlternateSiteAccountsByPortalIdAlternateResponse.js.map